/// <reference path="AccountGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class AccountPickerGrid extends AccountGrid {

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 50;
            return opt;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        get value() {
            return this.rowSelection.getSelectedKeys();
        }

        set value(value: string[]) {
            this.rowSelection.clear();
            this.rowSelection.setSelectedKeys(value || []);
        }

        private _criteria: any[];

        set criteria(value: any[]) {
            if (this._criteria != value) {
                this._criteria = value;
            }
        }

        private _hasModelTarget: string;

        set hasModelTarget(modelCode: string) {
            this._hasModelTarget = modelCode;
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            if (this._criteria != null)
                request.Criteria = Serenity.Criteria.and(request.Criteria, this._criteria);

            if (this._hasModelTarget) {
                request.EqualityFilter = request.EqualityFilter || {};
                request.EqualityFilter.HasModelTarget = this._hasModelTarget;
            }

            return true;
        }

        protected getItemCssClass(item, index) {
            var klass = super.getItemCssClass(item, index);
            if (this._hasModelTarget) {
                if (!(item as AccountRow).HasModelTarget)
                    return (klass || "") + " no-match-account";
            }
            return klass;
        }
    }
}